module.exports = {
      id: "ic-10-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-10-index-usage",
      toString: function () {
        return this.url;
      }
    }